import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetPlaceByUidApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        slug: z.string(),
        name: z.string(),
        description: z.any().optional().nullable(),
        images: z.array(
            z.object({
                url: z.string(),
            }),
        ).optional().nullable(),
        placeCategory: z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
        }).optional().nullable(),
    }),
});

type GetPlaceByUidApiResponse
    = ApiResponse<z.infer<typeof GetPlaceByUidApiResponseSchema>>
    | BaseError;

type GetPlaceByUidActionRequest = {
    uid: string,
}

export const getPlaceByUid = createAsyncThunk<
    GetPlaceByUidApiResponse,
    GetPlaceByUidActionRequest
>(
    'PlacePageActionsGetPlaceByUid',
    async ({
        uid,
    }) => apiInstance.get(
        `/s/places/${uid}`,
        {
            'populate[images][fields]': 'url',
            'populate[placeCategory][fields]': '*',
        },
        GetPlaceByUidApiResponseSchema,
    ),
);
